//this file contains functions so the organizer can change options 
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import {firestore as db} from './firebaseConfig';

//initializes a new empty session with default settings 
//adds the organizer as the session owner and adds an organizerSessions entry 
export const newSession = (adminId, sessionInfo) => {
    const ref = db.collection("meetings").doc()
    ref.set({
        chatOn: 1, 
        oneWayChat: false, 
        graphOn: true,
        creator: adminId
    }).then(()=> {});

    //adds the creator to organizerSessions
    var sessionId = ref.id;
    addOrganizerToSession(adminId, sessionId);
    setSessionName(sessionId, sessionInfo.name);
    setSessionTimeDate(sessionId, sessionInfo.time, sessionInfo.date);
    setSessionTopics(sessionId, sessionInfo.topics);
    setSessionReactions(sessionInfo.reactions, sessionInfo.colors, sessionId);
    setSessionOrganizers(sessionInfo.organizers, sessionId);
    console.log(sessionInfo.organizers);

    //adds empty votes, voteCount, and messages sub collections 
    db.collection("meetings").doc(sessionId).collection("votes").add({}).then(() => {});
    db.collection("meetings").doc(sessionId).collection("voteCount").add({}).then(() => {});
    db.collection("meetings").doc(sessionId).collection("messages").add({}).then(() => {});

}

//adds the organizer's id and email to organizer collection
//used when other users need to add an organizer by email
export function createOrganizer(organizerId, email){
    db.collection("organizers").doc(organizerId).set({
        email: email
    }).then(() => {
        console.log("Organizer saved to collection.")
    }).catch(err => {
        console.error("Error saving organizer: ", err)
    })
}

//returns an array of all registered organizers' emails and ids
export async function getAllOrganizers() {
    const snapshot = await db.collection("organizers").orderBy("email", "asc").get();
    if(snapshot.docs.length === 0) return null;
    return snapshot.docs.map((doc) => ({
        organizerId: doc.id,
        organizerEmail: doc.data().email}
    ))
}

export async function setSessionOrganizers(organizers, session_Id){
    for(const organizer_id of organizers){
        const snapshot = await db.collection("organizerSessions")
                        .where("organizerId", "==", organizer_id)
                        .where("sessionId", "==", session_Id).get();
        if(snapshot.docs.length === 0){
            addOrganizerToSession(organizer_id, session_Id)
            .then(() => {console.log("Created document for: ", organizer_id)});
        }
        else {
            console.log(`Organizer ${organizer_id} is already an organizer to this session.`);
        }
    }
}

//adds the inputted organizer to a session 
// used when a session is created (for creator) but can also be called to share access 
export function addOrganizerToSession(organizer_Id, session_Id){
    return db.collection("organizerSessions").add({
        organizerId: organizer_Id, 
        sessionId: session_Id
    });
}

//just so i can test things 
export const testFxn = () => {
    // const sessionId = "08RFMkkpmAcrSQ0p9YHL";
    // const reactions = ["agree", "disagree", "don't care"];
    // setSessionReactions(db, reactions, sessionId);
    
    // let p = Graph.getReactions(db, "xzI4AXYbCpFTzarZUetB");
    // console.log(p);

    //setSessionTopics(db, "xzI4AXYbCpFTzarZUetB", ["abc", "efg"]);

    // setSessionName(db, "xzI4AXYbCpFTzarZUetB", "testsessionname");
    // setSessionTimeDate(db, "xzI4AXYbCpFTzarZUetB", "testsessiontime", "testsessiondate");
    // let p = Graph.getSessionInfo(db, "xzI4AXYbCpFTzarZUetB");
    // console.log(p);

    toggleGraphView("xzI4AXYbCpFTzarZUetB");

}

// adds name to session
// takes in the db, sessionId, and sessionName 
export function setSessionName(sessionId, sessionName){
    db.collection("meetings").doc(sessionId).update({
        name: sessionName
    });
}

// adds field for session date and time 
// takes in the db, sessionId, and session date and time  
export function setSessionTimeDate(sessionId, sessionTime, sessionDate){
    db.collection("meetings").doc(sessionId).update({
        time: sessionTime,
        endTime: null,
        date: sessionDate
    });
}

// adds session topics for the organizer to select 
// takes in the db, sessionId, and topic array of strings 
export function setSessionTopics(sessionId, newtopics){
    db.collection("meetings").doc(sessionId).update({
        topics: newtopics
    })
}

//adds a topic stamp from an organizer 
// requires organizerId, sessionId, and the topic they selected 
export async function handleTopicClick(topic, sessionId, organizerId){
    //const spam = await checkVoteSpam(sessionId, organizerId);
    //if(spam.error) throw spam.message;
    //else {
        let collectionName = "meetings/" + sessionId + "/topicStamps";
        db.collection(collectionName).add({
            topic: topic, 
            timestamp: firebase.firestore.Timestamp.now(), 
            organizerId: organizerId
        })
    //}
}

//checks if a user voted 5 or less seconds ago
async function checkVoteSpam(sessionId, organizerId) {
    const clicks = await db.collection("meetings/" + sessionId + "/topicStamps")
                    .where("organizerId", "==", organizerId)
                    .where("timestamp", ">=", firebase.firestore.Timestamp.fromMillis(firebase.firestore.Timestamp.now().seconds*1000-5000)).get();

    if(clicks.size > 0) return {error: true, message: "too-many-clicks"}
    else return {error: false}
}

//takes in the database and an array of reaction strings : for example {"agree", "disagree"...}
// also adds colors of the reactions - seperate array correlate by index 
export const setSessionReactions = (reactions, colors, sessionId) => {
    const ref = db.collection("meetings").doc(sessionId).collection("voteCount");

    reactions.forEach(element => {
        ref.add({
            reaction: element,
            count: 0
        })
    });

    db.collection("meetings").doc(sessionId).update({
        reactions: reactions
    })

    db.collection("meetings").doc(sessionId).update({
        colors: colors
    })
}

//turn chat on/off for inputted session
export function toggleChat (sessionId, chatStatus){
    let currentMeeting = db.collection("meetings").doc(sessionId)

    currentMeeting.get().then(meeting => {
        currentMeeting.update({
            chatOn: chatStatus
        })
    });
}

//turn graph view on/off 
export function toggleGraphView(sessionId, graphStatus){
    let currentMeeting = db.collection("meetings").doc(sessionId)
    
    currentMeeting.get().then(meeting => {
        currentMeeting.update({
            graphOn: graphStatus
        })
    });
}

//flags a message and its user
export async function flagMessage(sessionId, messageId){
    let message = db.collection("meetings/" + sessionId + "/messages").doc(messageId)
    message.get().then((ref) => {
        if(ref.exists){
            console.log(`${ref.data().senderId} has been banned.`)
            flagUser(ref.data().senderId)
        }
    })
    message.update({
        flagged: true
    })
}

function flagUser(userId){
    db.collection("flaggedUsers").doc(userId).set({flagged: true})
}

export async function endMeeting(sessionId) {
    return await db.collection("meetings").doc(sessionId).update({
        endTime: firebase.firestore.Timestamp.now()
    });
}

export async function hasMeetingEnded(sessionId) {
    if(sessionId){
        const doc = await db.collection("meetings").doc(sessionId).get();
        if(doc.data()?.endTime) {
            return (doc.data().endTime !== null);
        }
    }
    return false;
}